angular.module('avatar.compnt', [])
    .component('avatar', {
        bindings: {
            avatarUrl: '<',
            avatarInitials: '<',
            fontSize: '@',
            size: '@',
            altText: '@',
            shadow: '@'
        },
        template: `<div class="avatarThumbnail "
                     ng-class="{'avatar__shadow': $ctrl.shadow}"
                     alt-text="{{$ctrl.altText}}"
                     ng-style="{'width': $ctrl.size, 'height': $ctrl.size}">
                        <div class="avatar__url" ng-if="$ctrl.avatarUrl"
                                preload-image="{{$ctrl.avatarUrl | imageByWidth: 400}}"></div>
                        <span ng-if="$ctrl.avatarInitials"
                             ng-style="{'font-size': $ctrl.fontSize}">
                                {{$ctrl.avatarInitials | uppercase}}
                        </span>
                    </div>`
    });

